import { render, staticRenderFns } from "./Venue.vue?vue&type=template&id=0ecfc190&scoped=true&"
import script from "./Venue.vue?vue&type=script&lang=js&"
export * from "./Venue.vue?vue&type=script&lang=js&"
import style0 from "./Venue.vue?vue&type=style&index=0&id=0ecfc190&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecfc190",
  null
  
)

export default component.exports